import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import Powerful from "../views/Powerful.vue";
import Colorful from "../views/Colorful.vue";
import Calm from "../views/Calm.vue";
import Gold from "../views/Gold.vue";

const routes = [
  {
    path: "/powerful",
    name: "powerful",
    component: Powerful,
  },
  {
    path: "/colorful",
    name: "colorful",
    component: Colorful,
  },
  {
    path: "/calm",
    name: "calm",
    component: Calm,
  },
  {
    path: "/gold",
    name: "gold",
    component: Gold,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "home",
    component: Home,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
    scrollBehavior(to) {
      if (to.hash) {
        return { el: to.hash };
    }
  },
});

export default router;
